module.exports = __webpack_public_path__ + "img/6.ffb77c60.png";